import React from "react";
import VVSTable from "components/form-control/VVSTable";
import { Container } from "reactstrap";

export default function TransactionInterest() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable
            title="Danh sách lãi đến kỳ"
            name="TransactionInterest"
            disableAdd
            whereQuery={{
              type: "interest",
              status: "requested",
            }}
            enableConfirmTransaction
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
